import { BACKEND_PARAMS } from "config";
import { useSearchParams } from "react-router-dom";

export const useLanguage = () => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang") ?? BACKEND_PARAMS.lang;
  return lang;
};
